import React from 'react';
import { Box, Typography } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';

export default function StarRating({ value = 0, onChange, size = 'medium', showLabel = false }) {
  const stars = [1, 2, 3, 4, 5];
  const iconSize = size === 'small' ? 18 : size === 'large' ? 32 : 24;

  return (
    <Box display="flex" alignItems="center" gap={0.25}>
      {stars.map((star) => {
        const filled = star <= value;
        const Icon = filled ? StarIcon : StarBorderIcon;
        return (
          <Icon
            key={star}
            sx={{
              fontSize: iconSize,
              color: filled ? '#f5a623' : '#ccc',
              cursor: onChange ? 'pointer' : 'default',
              transition: 'color 0.1s',
              '&:hover': onChange ? { color: '#f5a623' } : {},
            }}
            onClick={() => onChange && onChange(star)}
          />
        );
      })}
      {showLabel && value > 0 && (
        <Typography variant="body2" color="text.secondary" sx={{ ml: 0.5 }}>
          {value}/5
        </Typography>
      )}
    </Box>
  );
}
